import { Box, } from '@chakra-ui/react';
import React from 'react';


const Instructions = ({ props, isAccordion, setIsAccordion }) => {
  const stateProps = props.stateProps;
  return (

    <Box>
    </Box>
  );

};
export default Instructions;
